export const PDR_POD_BLOCK_CATEGORIES = { POD: 'POD', PDR: 'PDR' };

const defaultState = {
    isOpen: false,
    category: PDR_POD_BLOCK_CATEGORIES.PDR,
}


const PDR_POD_BLOCK_POPUP_SET_IS_OPEN = 'PDR_POD_BLOCK_POPUP_SET_IS_OPEN';
export const pdrPodBlockPopupSetIsOpen = (isOpen, category) => ({ 
    type: PDR_POD_BLOCK_POPUP_SET_IS_OPEN, 
    isOpen,
    category,
});

export const pdrPodBlockPopupTimeGateReducer = (state = defaultState, action) => {
    switch (action.type) {
        case PDR_POD_BLOCK_POPUP_SET_IS_OPEN: return { ...state, isOpen: action.isOpen, category: action.category }
        default: return state;
    }
}